import api from "../Api";

// helper: build auth headers from stored token
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// إنشاء فئة (يدعم form-data مع حقل image)
export const createCategory = async (formData) => {
  try {
    const headers = {
      "Content-Type": "multipart/form-data",
      ...getAuthHeaders(),
    };
    const response = await api.post("/admin/create-category", formData, {
      headers,
    });
    return response.data;
  } catch (error) {
    console.error("Error creating category:", error);
    throw error;
  }
};

// جلب جميع فئات الإدارة مع الشجرة (children_recursive) — يدعم params اختيارية
export const getAdminCategories = async (params = {}) => {
  try {
    const headers = {
      ...getAuthHeaders(),
    };
    const response = await api.get("/admin/get-categories", { params, headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin categories:", error);
    throw error;
  }
};

// جلب جميع منتجات الإدارة — يدعم params اختيارية ويضم هدر المصادقة
export const getAdminProducts = async (params = {}) => {
  try {
    const headers = {
      ...getAuthHeaders(),
    };
    const response = await api.get("/admin/get-all-products", { params, headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin products:", error);
    throw error;
  }
};

// دالة عامة لإرسال form-data إلى endpoint (افتراضي: create-category)
// usage: submitCategory(formData) أو submitCategory(formData, '/admin/update-category')
export const submitCategory = async (formData, endpoint = "/admin/create-category") => {
  try {
    // normalize status when formData provided
    if (typeof FormData !== "undefined" && formData instanceof FormData) {
      const statusVal = formData.get("status");
      if (statusVal !== null) {
        // map common representations to '1' or '0'
        if (statusVal === true || statusVal === "true" || statusVal === "1" || statusVal === 1 || statusVal === "active") {
          formData.set("status", "1");
        } else if (statusVal === false || statusVal === "false" || statusVal === "0" || statusVal === 0 || statusVal === "inactive") {
          formData.set("status", "0");
        }
      }
    }

    const headers = {
      "Content-Type": "multipart/form-data",
      ...getAuthHeaders(),
    };
    const response = await api.post(endpoint, formData, { headers });
    return response.data;
  } catch (error) {
    console.error(`Error submitting category to ${endpoint}:`, error);
    // surface validation errors if present
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach(v => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

export const updateCategory = async (formData) => {
  // هات الـ id من formData زي ما Postman بيبعت category_id
  const id =
    formData.get("id") ||
    formData.get("category_id") ||
    formData.get("categoryId");

  if (!id) throw new Error("category_id is required to update category.");

  // normalize status similar to submitCategory (use '1' / '0' to satisfy backend validation)
  if (typeof FormData !== "undefined" && formData instanceof FormData) {
    const statusVal = formData.get("status");
    if (statusVal !== null) {
      if (statusVal === true || statusVal === "true" || statusVal === "1" || statusVal === 1 || statusVal === "active") {
        formData.set("status", "1");
      } else if (statusVal === false || statusVal === "false" || statusVal === "0" || statusVal === 0 || statusVal === "inactive") {
        formData.set("status", "0");
      }
    }
  }

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };

  // api_password kept as params to allow axios encoding
  const params = {
    api_password: "EcommercApp@2026_$",
  };

  try {
    // corrected endpoint spelling: update-category
    const response = await api.post(`/admin/update-categroy/${id}`, formData, {
      headers,
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error);
    // surface validation errors if present
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach(v => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};



